import React, { FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import {
  ModalWithBackdrop,
  ModalWithBackdropProps
} from '../ModalWithBackdrop/ModalWithBackdrop';
import styles from './ConfirmModal.module.css';

export type ConfirmModalProps = ModalWithBackdropProps & {
  /** default: Default */
  widthType?: ConfirmModalWidthType;
};

export enum ConfirmModalWidthType {
  Default = 'default',
  Auto = 'auto'
}

export const ConfirmModal: FunctionComponent<ConfirmModalProps> = React.memo(
  (props) => {
    const {
      widthType = ConfirmModalWidthType.Default,
      children,
      ...remainingProps
    } = prepareProps({ props });

    return (
      <ModalWithBackdrop {...remainingProps}>
        <div
          className={classes(styles.dialog, widthTypeToClassName[widthType])}
        >
          {children}
        </div>
      </ModalWithBackdrop>
    );
  }
);

const widthTypeToClassName: Record<ConfirmModalWidthType, string | null> = {
  [ConfirmModalWidthType.Default]: styles.widthTypeDefault,
  [ConfirmModalWidthType.Auto]: null
};
